import { render } from "./ClientAuthorizedAddScopeModal.vue?vue&type=template&id=cd20967a"
import script from "./ClientAuthorizedAddScopeModal.vue?vue&type=script&lang=js"
export * from "./ClientAuthorizedAddScopeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__